/*
 * Copyright (c) 2019 Tetherfi Pte. Ltd. (www.tetherfi.com).
 * All rights reserved.
 *
 * This source code is property of Tetherfi Pte. Ltd. product suit. Any use of this code in any
 * form, for any purpose is strictly prohibited unless prior written permission is obtained from
 * Tetherfi Pte. Ltd.
 *
 * file :: browser_utils.js
 * Description :: JS library to get browser related infomation and other browser utils
 */

//browser utils object
var utils = {};
//file version
utils.version = "1.2.04.25";
//browser navigator user agent
utils.ua = navigator.userAgent;
//to detect operating system which returns these os win10, winvista, win7, win8, winxp, winnt, mac, linux, nix
utils.DetectOS = function () {
  return /Windows NT 10/.test(utils.ua) ?
    "win10" :
    /Windows NT 6\.0/.test(utils.ua) ?
    "winvista" :
    /Windows NT 6\.1/.test(utils.ua) ?
    "win7" :
    /Windows NT 6\.\d/.test(utils.ua) ?
    "win8" :
    /Windows NT 5\.1/.test(utils.ua) ?
    "winxp" :
    /Windows NT [1-5]\./.test(utils.ua) ?
    "winnt" :
    /Mac/.test(utils.ua) ?
    "mac" :
    /Linux/.test(utils.ua) ?
    "linux" :
    /X11/.test(utils.ua) ?
    "nix" :
    "";
};
//to detect browser which returns ed, ie, ie9, ie10, ie11, ff, gc, oc, sa, op
utils.DetectBrowser = function () {
  return /Edge\/\d+/.test(utils.ua) ?
    "ed" :
    /MSIE 9/.test(utils.ua) ?
    "ie9" :
    /MSIE 10/.test(utils.ua) ?
    "ie10" :
    /MSIE 11/.test(utils.ua) ?
    "ie11" :
    /MSIE\s\d/.test(utils.ua) ?
    "ie?" :
    /rv\:11/.test(utils.ua) ?
    "ie11" :
    /Firefox\W\d/.test(utils.ua) ?
    "ff" :
    /Chrome\W\d/.test(utils.ua) ?
    "gc" :
    /Chromium\W\d/.test(utils.ua) ?
    "oc" :
    /\bSafari\W\d/.test(utils.ua) ?
    "sa" :
    /\bOpera\W\d/.test(utils.ua) ?
    "op" :
    /\bOPR\W\d/i.test(utils.ua) ?
    "op" :
    typeof MSPointerEvent !== "undefined" ?
    "ie?" :
    "";
};
//to detect if the device is mobile
utils.IsMobile = function () {
  return (
    (utils.ua.match(/IEMobile|Windows Phone|Lumia/i) ||
      utils.ua.match(/iPhone|iP[oa]d/) ||
      utils.ua.match(/Android/) ||
      utils.ua.match(/BlackBerry|PlayBook|BB10/) ||
      utils.ua.match(/Mobile Safari/) ||
      utils.ua.match(/webOS|Mobile|Tablet|Opera Mini|\bCrMo\/|Opera Mobi/i)) !==
    null
  );
};
//to detect the mobile OS
utils.DetectMobileOS = function () {
  return utils.ua.match(/IEMobile|Windows Phone|Lumia/i) ?
    "Windows" :
    utils.ua.match(/iPhone|iP[oa]d/) ?
    "IOS" :
    utils.ua.match(/Android/) ?
    "Android" :
    utils.ua.match(/BlackBerry|PlayBook|BB10/) ?
    "BlackBerry" :
    utils.ua.match(/Mobile Safari/) ?
    "Safari" :
    utils.ua.match(/webOS|Mobile|Tablet|Opera Mini|\bCrMo\/|Opera Mobi/i) ?
    "O" :
    "";
};
//to detect if the device is tablet
utils.IsTablet = function () {
  return utils.ua.match(/Tablet|iPad/i) !== null;
};
//to detect if the window is touch screen
utils.IsTouch = function () {
  return "ontouchstart" in document.documentElement;
};
//to get the width of the window
utils.GetWindowWidth = function () {
  return window.innerWidth;
};
//to get the height of the window
utils.GetWindowHeight = function () {
  return window.innerHeight;
};
//get the query string values
utils.GetQueryString = function (key) {
  let href = window.location.href;
  let reg = new RegExp("[?&]" + key.toLowerCase() + "=([^&#]*)", "i");
  let string = reg.exec(href);
  return string ? string[1] : "";
};
//get local storage item
utils.GetLocalStorage = function (key) {
  return localStorage.getItem(key);
};
//set local storage item
utils.SetLocalStorage = function (key, value) {
  localStorage.setItem(key, value);
};
//remove local storage
utils.RemoveLocalStorage = function (key) {
  localStorage.removeItem(key);
};

//get local storage item
utils.GetSessionStorage = function (key) {
  return sessionStorage.getItem(key);
};
//set local storage item
utils.SetSessionStorage = function (key, value) {
  sessionStorage.setItem(key, value);
};
//remove local storage
utils.RemoveSessionStorage = function (key) {
  sessionStorage.removeItem(key);
};

//check if the string is JSON string
utils.IsJsonMessage = function (jsonString) {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (error) {
    return false;
  }
};
//returns json object after parsing
utils.JParse = function (jsonString) {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    return null;
  }
};
//returns json string after stringfying
utils.JString = function (json) {
  try {
    return JSON.stringify(json);
  } catch (error) {
    console.log(error);
  }
  return "{}";
};
//check if the string is a valid json string or not
utils.IsValidJson = function (text) {
  var isJson = false;
  try {
    var jParse = JSON.parse(text);
    if (typeof jParse === "object") {
      isJson = true;
    } else {
      isJson = false;
    }
  } catch (ex) {
    isJson = false;
  }
  return isJson;
};
//get the element by id
utils.GetById = function (id) {
  return document.getElementById(id);
};
//scroll to the bottom of element
utils.ScrollToBottom = function (id) {
  //scroll to top after appening the message div
  if (this.GetById(id))
    this.GetById(id).scrollTop = this.GetById(id).scrollHeight;
};

utils.ValidateInput = function (type, value) {
  var isValid = false;
  try {
    var regex = null;
    if (type === "alphanumeric") {
      //Regex for Valid Characters i.e. Alphabets and Numbers.
      regex = /^[A-Za-z0-9]+$/;
      isValid = regex.test(value);
    }
  } catch (error) {}
  return isValid;
};
try {
  window.b_utils = window.$b = utils;
  exports.b_utils = exports.$b = utils;
} catch (error) {}
